/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineIdUsersGradesBatch202,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatch400,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatch401,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatch404,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatchMutationRequest,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatchMutationResponse,
  PatchApiV1ClassroomdisciplineIdUsersGradesBatchPathParams,
} from "../../types/classPlanningPeopleController/PatchApiV1ClassroomdisciplineIdUsersGradesBatch.ts";
import { modifyGradeBatchRequestViewModelSchema } from "../modifyGradeBatchRequestViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineIdUsersGradesBatchPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatchPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ClassroomdisciplineIdUsersGradesBatch202Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ClassroomdisciplineIdUsersGradesBatch400Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineIdUsersGradesBatch401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatch401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ClassroomdisciplineIdUsersGradesBatch404Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatch404>;

export const patchApiV1ClassroomdisciplineIdUsersGradesBatchMutationRequestSchema =
  z.lazy(
    () => modifyGradeBatchRequestViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatchMutationRequest>;

export const patchApiV1ClassroomdisciplineIdUsersGradesBatchMutationResponseSchema =
  z.lazy(
    () => patchApiV1ClassroomdisciplineIdUsersGradesBatch202Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersGradesBatchMutationResponse>;
